

import Cobra1 from '../assets/images/king/1.jpeg';
import Cobra2 from '../assets/images/king/2.jpeg';
import Cobra3 from '../assets/images/king/3.jpeg';
import Cobra4 from '../assets/images/king/4.jpeg';
import Cobra5 from '../assets/images/king/5.png';

import Podi1 from '../assets/images/product/purapodi/1.jpeg';
import Podi2 from '../assets/images/product/purapodi/2.jpeg';
import Podi3 from '../assets/images/product/purapodi/3.jpeg';

import ChairNew from '../assets/images/product/chair/1.jpeg';
import Table1 from '../assets/images/product/table/1.jpeg';
import Bed1 from '../assets/images/product/bed/bed-1.jpeg';
import AakeshyaChair from '../assets/images/product/akesya/chair-1.jpeg'
import AakeshyaChair2 from '../assets/images/product/akesya/chair-2.jpeg'
import AakeshyaCupboard from '../assets/images/product/akesya/cupboard-1.jpeg'
import CurvaSofa from '../assets/images/product/chair/chair.jpeg'
import Sofa1 from '../assets/images/product/sofa/sofa-1.jpeg'
import Sofa2 from '../assets/images/product/sofa/sofa-2.jpeg'
import Dress1 from '../assets/images/product/Dress/7.jpeg'
import Dress2 from '../assets/images/product/Dress/2.jpeg'
import Dress3 from '../assets/images/product/Dress/3.jpeg'
import Dress4 from '../assets/images/product/Dress/4.jpeg'
import Dress5 from '../assets/images/product/Dress/5.jpeg'
import Dress6 from '../assets/images/product/Dress/6.jpeg'
import Dress7 from '../assets/images/product/Dress/1.jpeg'
import Dress8 from '../assets/images/product/Dress/8.jpeg'
import Dress9 from '../assets/images/product/Dress/9.jpeg'
import Dress10 from '../assets/images/product/Dress/10.jpeg'
import Plug1 from '../assets/images/product/wall-plug/1.jpeg'
import IronTable1 from '../assets/images/product/unbox-holder/1.jpeg'
import IronTable2 from '../assets/images/product/unbox-holder/2.jpeg'
import IronTable3 from '../assets/images/product/unbox-holder/3.jpeg'
import IronTable4 from '../assets/images/product/unbox-holder/4.jpeg'
import IronTable5 from '../assets/images/product/unbox-holder/5.jpeg'
import IronTable6 from '../assets/images/product/unbox-holder/6.jpeg'
import IronTable7 from '../assets/images/product/unbox-holder/7.jpeg'
import medicine1 from '../assets/images/product/medicie/1.jpeg'
import medicine2 from '../assets/images/product/medicie/2.jpeg'
import Thailam1 from '../assets/images/product/murivenna/1.jpeg'
import Thailam2 from '../assets/images/product/murivenna/2.jpeg'
import SweetPotato1 from '../assets/images/product/ojeenam/1.jpeg'
import SweetPotato2 from '../assets/images/product/ojeenam/4.jpeg'
import Kunnankaya1 from '../assets/images/product/ojeenam/2.jpeg'
import Healthmix1 from '../assets/images/product/ojeenam/3.jpeg'
import NavaraRagiPowder from '../assets/images/product/ojeenam/5.jpeg'
import NavaraBananaMix from '../assets/images/product/ojeenam/6.jpeg'
import NavaraRicePowder from '../assets/images/product/ojeenam/7.jpeg'
import Panchaloha1 from '../assets/images/product/traditional-Jewellery/punjaloha-1.jpeg'
import Panchaloha2 from '../assets/images/product/traditional-Jewellery/punjaloha-2.jpeg'
import Panchaloha3 from '../assets/images/product/traditional-Jewellery/punjaloha-3.jpeg'
import Panchaloha4 from '../assets/images/product/traditional-Jewellery/punjaloha-4.jpeg'
import Panchaloha5 from '../assets/images/product/traditional-Jewellery/punjaloha-5.jpeg'
import Panchaloha6 from '../assets/images/product/traditional-Jewellery/chain-3.jpeg'
import Panchaloha7 from '../assets/images/product/traditional-Jewellery/chain-2.jpeg'
import Panchaloha8 from '../assets/images/product/traditional-Jewellery/chain-1.jpeg'
import PanchalohaRing1 from '../assets/images/product/traditional-Jewellery/rings/ring-1.jpeg';
import PanchalohaRing2 from '../assets/images/product/traditional-Jewellery/rings/ring-2.jpeg';
import PanchalohaRing3 from '../assets/images/product/traditional-Jewellery/rings/ring-3.jpeg';
import PanchalohaRing4 from '../assets/images/product/traditional-Jewellery/rings/ring-4.jpeg';
import PanchalohaRing5 from '../assets/images/product/traditional-Jewellery/rings/ring-5.jpeg';
import PanchalohaRing6 from '../assets/images/product/traditional-Jewellery/rings/ring-6.jpeg';
import PanchalohaRing7 from '../assets/images/product/traditional-Jewellery/rings/ring-7.jpeg';
import PanchalohaRing8 from '../assets/images/product/traditional-Jewellery/rings/ring-8.jpeg';
import PanchalohaRing9 from '../assets/images/product/traditional-Jewellery/rings/ring-9.jpeg';
import PanchalohaRing10 from '../assets/images/product/traditional-Jewellery/rings/ring-10.jpeg';
import PanchalohaRing11 from '../assets/images/product/traditional-Jewellery/rings/ring-11.jpeg';
import PanchalohaRing12 from '../assets/images/product/traditional-Jewellery/rings/ring-12.jpeg';
import PanchalohaRing13 from '../assets/images/product/traditional-Jewellery/rings/ring-13.jpeg';
import PanchalohaRing14 from '../assets/images/product/traditional-Jewellery/rings/ring-14.jpeg';
import PanchalohaRing15 from '../assets/images/product/traditional-Jewellery/rings/ring-15.jpeg';
import PanchalohaRing16 from '../assets/images/product/traditional-Jewellery/rings/ring-16.jpeg';
import PanchalohaRing17 from '../assets/images/product/traditional-Jewellery/rings/ring-17.jpeg';
import PanchalohaRing18 from '../assets/images/product/traditional-Jewellery/rings/ring-18.jpeg';
import PanchalohaRing19 from '../assets/images/product/traditional-Jewellery/rings/ring-19.jpeg';
import PanchalohaRing20 from '../assets/images/product/traditional-Jewellery/rings/ring-20.jpeg';
import PanchalohaRing21 from '../assets/images/product/traditional-Jewellery/rings/ring-21.jpeg';
import PanchalohaRing22 from '../assets/images/product/traditional-Jewellery/rings/ring-22.jpeg';
import PanchalohaRing23 from '../assets/images/product/traditional-Jewellery/rings/ring-23.jpeg';
import PanchalohaRing24 from '../assets/images/product/traditional-Jewellery/rings/ring-24.jpeg';
import PanchalohaRing25 from '../assets/images/product/traditional-Jewellery/rings/ring-25.jpeg';
import PanchalohaRing26 from '../assets/images/product/traditional-Jewellery/rings/ring-26.jpeg';
import PanchalohaRing27 from '../assets/images/product/traditional-Jewellery/rings/ring-27.jpeg';
import PanchalohaRing28 from '../assets/images/product/traditional-Jewellery/rings/ring-28.jpeg';
import SulthanPerfume1 from '../assets/images/product/perfume/sulthan/1.jpeg';
import SulthanPerfume2 from '../assets/images/product/perfume/sulthan/2.jpeg';
import SulthanPerfume3 from '../assets/images/product/perfume/sulthan/3.jpeg';
import SulthanPerfume5 from '../assets/images/product/perfume/sulthan/5.jpeg';
import SulthanPerfume6 from '../assets/images/product/perfume/sulthan/6.jpeg';
import SulthanPerfume7 from '../assets/images/product/perfume/sulthan/7.jpeg';
import SulthanPerfume8 from '../assets/images/product/perfume/sulthan/8.jpeg';
import NeemSoap from '../assets/images/product/soap/neem/neem-soap.png';
import PawpetalsPlanter1 from '../assets/images/product/plant/plant-1.jpeg';
import PawpetalsPlanter2 from '../assets/images/product/plant/plant-2.jpeg';
import PawpetalsPlanter3 from '../assets/images/product/plant/plant-3.jpeg';
import PawpetalsPlant1 from '../assets/images/product/plant/plant-4.jpeg';
import PawpetalsPlant2 from '../assets/images/product/plant/plant-5.jpeg';
import PawpetalsPlant3 from '../assets/images/product/plant/plant-6.jpeg';
import PawpetalsPlant4 from '../assets/images/product/plant/plant-7.jpeg';
import PawpetalsPlant5 from '../assets/images/product/plant/plant-8.jpeg';
import PawpetalsPlant6 from '../assets/images/product/plant/plant-9.jpeg';
import hardware from '../assets/images/product/hard-ware/plumbling.jpeg';
import hardwareLogo from '../assets/images/product/hard-ware/logo.jpeg';
import Hook1 from '../assets/images/product/Wall-Hooks/hook-1.jpeg';
import Hook2 from '../assets/images/product/Wall-Hooks/hook-2.jpeg';
import Hook3 from '../assets/images/product/Wall-Hooks/hook-3.jpeg';
import Hook4 from '../assets/images/product/Wall-Hooks/hook-4.jpeg';
import Hook5 from '../assets/images/product/Wall-Hooks/hook-5.jpeg';
import Hook6 from '../assets/images/product/Wall-Hooks/hook-6.jpeg';
import loundryPods1 from '../assets/images/product/diawan-mart/1.jpeg';
import loundryPods2 from '../assets/images/product/diawan-mart/2.jpeg';
import storageBagImage from '../assets/images/product/diawan-mart/3.jpeg';
import storageBagImage1 from '../assets/images/product/diawan-mart/4.jpeg';
import markerPenImage from '../assets/images/product/diawan-mart/6.jpeg';
import cerealDispenserImage from '../assets/images/product/diawan-mart/7.jpeg';
import drawerOrganizerImage from '../assets/images/product/diawan-mart/9.jpeg';
import kidsProjectorImage from '../assets/images/product/diawan-mart/10.jpeg';
import ledFlashlightImage from '../assets/images/product/diawan-mart/11.jpeg';
export const PRODUCT_DATA_VERSION = 'v2.0.3';

export const products = [
    {
        id: "29",
        title: 'Rajabi Homemade Poora Podi',
        category: 'Grocery',
        content: 'Traditional South Indian Spice Blend',
        oldPrice: '410',
        offer: "17%",
        offerPrice: "360",
        count: 50,
        gallery: [Podi2, Podi1, Podi3],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Rajabi Homemade Poora Podi is a traditional South Indian spice blend made with carefully roasted lentils, aromatic spices, and a touch of love from our kitchen. Packed with rich flavor and natural goodness, this versatile podi pairs perfectly with hot rice, ghee, dosa, idli, or chapati. Free from preservatives and artificial additives, it delivers authentic homemade taste in every spoonful — simple, wholesome, and delicious.",
        subDescription: "Rajabi Homemade Poora Podi is hand-crafted in small batches to ensure premium quality and fresh flavor. Each ingredient is sun-dried and slow-roasted to perfection, capturing the essence of traditional South Indian culinary heritage.",
        subContent: "Homemade Taste | No Preservatives | Traditional Recipe"
    },
    {
        id: "30",
        title: 'Teak Elegance Upholstered Dining Chair',
        category: 'Furniture',
        content: 'Premium Akeshya Edition Dining Chair',
        oldPrice: '4000',
        offer: "13%",
        offerPrice: "3499",
        count: 60,
        gallery: [ChairNew],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "This Teak Elegance Upholstered Dining Chair (Akeshya Edition) is crafted from solid teak wood, offering strength, durability, and timeless appeal. The softly cushioned seat and quilted backrest provide excellent comfort, while the warm wood finish adds a touch of natural charm to any dining or living space.",
        subDescription: "Special Akeshya Edition with enhanced finish and competitive pricing. Perfect for bulk orders or high-end residential projects.",
        subContent: "Akeshya Edition | Solid Teak | Modern Comfort"
    },
    {
        id: "31",
        title: 'Akeshiya 6-Seater Glass Top Dining Table',
        category: 'Furniture',
        content: 'Premium Solid Wood with Elegant Glass Top',
        oldPrice: '12500',
        offer: "12%",
        offerPrice: "10999",
        count: 35,
        gallery: [Table1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "The Akeshiya 6-Seater Dining Table is crafted from premium solid wood, designed with a strong cross-leg base for stability and modern appeal. The smooth glass top enhances its elegance while offering easy maintenance and everyday durability. Perfect for family dining and gatherings, this table blends contemporary style with long-lasting craftsmanship, making it a beautiful centerpiece for any dining space.",
        subDescription: "This contemporary dining table features a 10mm tempered glass top and a robust solid wood frame. The artistic cross-leg design provides superior stability while creating a modern aesthetic that complements any dining room decor.",
        subContent: "6-Seater Capacity | Tempered Glass Top | Solid Wood Base"
    },
    {
        id: "32",
        title: 'Aakeshya Upholstered Wooden Bed',
        category: 'Furniture',
        content: 'Solid Wood Bed with Cushioned Headboard',
        oldPrice: '16500',
        offer: "15%",
        offerPrice: "14000",
        count: 42,
        gallery: [Bed1],
        sizes: ['6.25 x 5 ft', '6.25 x 6 ft'],
        colors: ['Akeshya Wood', 'Teak Wood'],
        variants: [
            { size: '6.25 x 5 ft', color: 'Akeshya Wood', price: 14000, oldPrice: 16500 },
            { size: '6.25 x 6 ft', color: 'Akeshya Wood', price: 19000, oldPrice: 22500 },
            { size: '6.25 x 5 ft', color: 'Teak Wood', price: 17000, oldPrice: 20000 },
            { size: '6.25 x 6 ft', color: 'Teak Wood', price: 24000, oldPrice: 28500 }
        ],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Aakeshya Upholstered Wooden Bed features a solid wooden frame paired with a softly tufted cushioned headboard for enhanced comfort and elegance. Its smooth rounded edges and sturdy base provide lasting durability while maintaining a warm, modern aesthetic. Designed to complement contemporary and classic interiors alike, this bed offers excellent support and a refined finish, making it ideal for stylish and comfortable bedrooms.",
        subDescription: "Crafted with precision using high-quality Akeshya and Teak wood, this bed combines structural integrity with a luxurious upholstered finish. The headboard is designed for ergonomic support, perfect for reading or relaxing.",
        subContent: "Solid Wood Frame | Tufted Upholstered Headboard | Available in 2 Sizes & 2 Finishes"
    },
    {
        id: "36",
        title: 'Plain X Wooden Dining Chair',
        category: 'Furniture',
        content: 'Solid Wood | Cross-Back Design | Rich Wood Tone',
        oldPrice: '1550',
        offer: "19%",
        offerPrice: "1250",
        count: 50,
        gallery: [AakeshyaChair2],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Plain X Wooden Dining Chair features a strong solid wood frame with a stylish cross-back design that adds both support and visual appeal. The smooth slatted seat ensures comfortable seating, while the sturdy legs provide long-lasting stability. Finished in a rich wood tone, this chair is ideal for dining spaces, cafes, and modern interiors, blending durability with timeless design.",
        subDescription: "This chair is designed for both style and durability. The X-back provides excellent lumbar support, while the classic silhouette fits into any dining environment.",
        subContent: "Solid Wood Frame | Cross-back Support | Ergonomic Seating"
    },
    {
        id: "37",
        title: 'Plain X Wooden Dining Chair (Akeshya Wood Edition)',
        category: 'Furniture',
        content: 'Solid Wood | Cross-Back Design | Premium Finish',
        oldPrice: '1700',
        offer: "15%",
        offerPrice: "1450",
        count: 45,
        gallery: [AakeshyaChair],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Plain X Wooden Dining Chair features a strong solid wood frame with a stylish cross-back design that adds both support and visual appeal. The smooth slatted seat ensures comfortable seating, while the sturdy legs provide long-lasting stability. Finished in a rich wood tone, this chair is ideal for dining spaces, cafes, and modern interiors, blending durability with timeless design.",
        subDescription: "Special Akeshya edition with a premium finish. The cross-back design provides superior stability and comfort for any dining setup.",
        subContent: "Premium Akeshya Wood | Durable Structure | Stylish Design"
    },
    {
        id: "38",
        title: 'Aakeshya 4-Door Wooden Wardrobe (Akeshya Wood)',
        category: 'Furniture',
        content: '4-Door | Solid Akeshya Wood | Spacious Internal Storage',
        oldPrice: '38000',
        offer: "15%",
        offerPrice: "32000",
        count: 15,
        gallery: [AakeshyaCupboard],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Aakeshya 4-Door Wooden Wardrobe features a strong solid wood construction with beautifully crafted panel doors that add character and elegance to any bedroom. Designed with spacious internal storage, it offers ample room for clothes, linens, and accessories while ensuring long-term durability. Its clean lines and rich natural finish make it a perfect blend of modern style and timeless craftsmanship.",
        subDescription: "Crafted from premium Akeshya wood, this wardrobe features four massive compartments with adjustable shelving and hanging rods. The panelled doors provide a sophisticated look that complements any interior.",
        subContent: "Solid Wood Constuction | 4-Door Design | Ample Storage"
    },
    {
        id: "39",
        title: 'COBRA ROMANCE',
        category: 'Health & Wellness',
        content: 'Strategy: Dark Luxury Aesthetics + Clinical Trust Triggers',
        oldPrice: '1699',
        offer: "23%",
        offerPrice: "1299",
        count: 23,
        gallery: [Cobra1, Cobra5, Cobra2, Cobra3, Cobra4],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Cobra Romance is a premium Ayurvedic formula for natural strength and lasting intimacy. It activates within 30 minutes and delivers results for up to 4 days. Made using advanced Thanthu Paka extraction for 2.5× potency. Clinically safe with no headaches, BP spikes, or addiction. 100% private shipping with government-approved quality.",
        subDescription: "Cobra Romance is a government-approved Ayurvedic formulation designed to restore natural strength, stamina, and romantic confidence without harmful chemicals or artificial stimulants. Crafted using the advanced Thanthu Paka extraction method, it delivers 2.5× higher herbal potency for faster absorption and longer-lasting results.",
        subContent: "Cobra Romance is a premium Ayurvedic vitality formula crafted to enhance stamina, confidence, and deep romantic connection naturally. Powered by advanced Thanthu Paka extraction, it delivers faster absorption and long-lasting results without harmful chemicals or side effects."
    },
    {
        id: "40",
        title: 'Industrial Metal Chair',
        category: 'Furniture',
        content: 'Durable metal construction with ergonomic design',
        oldPrice: '11000',
        offer: "18%",
        offerPrice: "9000",
        count: 143,
        gallery: [ChairNew],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Industrial-grade metal chair designed for both indoor and outdoor use. The rust-resistant coating ensures longevity, while the ergonomic seat provides comfort for extended periods.",
        subDescription: "Perfect for cafes, dining rooms, and patios. The stackable design allows for easy storage when not in use.",
        subContent: "Metal Frame | Rust Resistant | Stackable"
    },
    {
        id: "41",
        title: 'Curva Teak Wooden Sofa Set (3-Seater)',
        category: 'Furniture',
        content: '3-Seater | Premium Teak Wood | Ergonomic Design',
        oldPrice: '10500',
        offer: "10%",
        offerPrice: "9500",
        count: 10,
        gallery: [CurvaSofa],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Crafted from premium teak wood, this 3-seater sofa set features a beautifully curved slatted back and contoured seat for enhanced comfort and durability. Its smooth armrests and sturdy frame make it ideal for both living rooms and sit-out spaces, blending classic design with everyday functionality. A perfect choice for those who value natural wood elegance and long-lasting quality.",
        subDescription: "The Curva Teak Sofa is designed with an emphasis on both aesthetics and ergonomics. The contoured seat provides superior lumbar support, while the high-grade teak wood ensures it remains a centerpiece in your home for years to come.",
        subContent: "Premium Teak Wood | Curved Slatted Back | Durable Frame"
    },
    {
        id: "42",
        title: 'Regal Comfort L-Shape Sofa Set',
        category: 'Furniture',
        content: 'L-Shape Design | Premium Upholstery | High-Density Cushioning',
        oldPrice: '24000',
        offer: "6%",
        offerPrice: "22500",
        count: 25,
        gallery: [Sofa2, Sofa1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Experience true luxury with the Regal Comfort L-Shape Sofa Set, designed for spacious living and elegant interiors. Crafted with premium-quality upholstery and high-density cushioning, this sofa offers superior comfort and long-lasting durability. The sleek wooden base detailing adds a refined touch, while the wide seating space makes it perfect for family gatherings and relaxation. Its modern yet timeless design blends beautifully with both contemporary and classic home décor.",
        subDescription: "The Regal Comfort L-Shape Sofa Set is the epitome of luxury and functionality. With its ergonomic design and spacious seating, it provides the perfect setting for hosting guests or enjoying quality family time. The premium upholstery ensures easy maintenance while the high-density foam cushioning retains its shape for years.",
        subContent: "L-Shape Design | Premium Upholstery | Wooden Base Detailing"
    },
    {
        id: "43",
        title: 'Emerald Grace Embroidered Salwar Suit Set',
        category: 'Fashion',
        content: 'Elegant Teal Salwar Suit | 3-Piece & 2-Piece Options Available',
        oldPrice: '1450',
        offer: "31%",
        offerPrice: "999",
        count: 45,
        gallery: [Dress1, Dress2, Dress3, Dress4, Dress5, Dress6, Dress7],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "This elegant teal salwar suit set is designed to bring timeless charm and graceful sophistication. The kurta features delicate embroidery accents along the neckline, hem, and borders, adding a refined traditional touch. Paired with matching straight-fit pants and a beautifully coordinated dupatta with subtle woven detailing, this outfit offers a perfect balance of simplicity and elegance. Crafted for comfort and style, it is ideal for festive occasions, family gatherings, and cultural events. The rich color and fine craftsmanship create a graceful silhouette, making it a standout addition to any ethnic wardrobe.",
        subDescription: "Available in two options: 3-piece set (Kurta + Pants + Dupatta) at MRP ₹1450, SRP ₹999 | 2-piece set (Kurta + Pants) at MRP ₹550, SRP ₹330. Both options feature premium fabric quality and intricate embroidery work that showcases traditional craftsmanship.",
        subContent: "3-Piece MRP ₹1450, SRP ₹999 | 2-Piece MRP ₹550, SRP ₹330 | Embroidered Design | Premium Fabric"
    },
    {
        id: "44",
        title: 'Ruby Grace Embroidered Salwar Set',
        category: 'Fashion',
        content: 'Ruby Grace Embroidered Salwar Set 2-Piece Options Available',
        oldPrice: '750',
        offer: "26%",
        offerPrice: "550",
        count: 45,
        gallery: [Dress8, Dress9],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Step into elegance with the Ruby Grace Embroidered Salwar Set. This stunning red kurta features delicate golden embroidery on the neckline, sleeves, and hem, adding a rich traditional charm. Paired with matching straight-fit pants and a coordinated dupatta, this set is perfect for festive occasions, family gatherings, and celebrations. Crafted from soft, breathable fabric, it ensures comfort while keeping your look graceful and classy."
    },
    {
        id: "45",
        title: 'Plum Petal Printed Salwar Set',
        category: 'Fashion',
        content: 'Plum Petal Printed Salwar Set 2-Piece Options Available',
        oldPrice: '550',
        offer: "40%",
        offerPrice: "330",
        count: 45,
        gallery: [Dress10],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Add a touch of graceful charm to your everyday ethnic style with the Plum Petal Printed Salwar Set. Designed in a rich plum shade, this elegant kurta features delicate floral-inspired prints throughout, offering a perfect blend of tradition and modern simplicity. Paired with matching straight-fit pants and a soft, lightweight dupatta, this set ensures both comfort and effortless style. Ideal for casual outings, office wear, and small gatherings."
    },
    {
        id: "46",
        title: 'Butterfly Wall Plug Anchor',
        category: 'Hardware',
        content: 'Butterfly Wall Plug Anchor (Plastic Hollow Wall Anchor) – 32×10mm, Heavy-Duty Fixing Plug',
        oldPrice: '450',
        offer: "22%",
        offerPrice: "350",
        count: 45,
        gallery: [Plug1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "The Butterfly Wall Plug Anchor is a strong and reliable fixing solution designed for hollow walls such as plywood, gypsum boards, MDF, and hollow doors. Its unique butterfly-wing design expands behind the surface when the screw is tightened, providing a firm grip and preventing slipping or loosening. Made from high-quality durable plastic, this wall plug ensures secure mounting for lightweight to medium-weight items like shelves, curtain rods, frames, clocks, and decorative fixtures."
    },
    {
        id: "47",
        title: 'Foldable Ironing Table!',
        category: 'Furniture',
        content: 'Wall-Mountable Foldable Iron Table | Space-Saving Design',
        oldPrice: '4000',
        offer: "25%",
        offerPrice: "3000",
        count: 50,
        gallery: [IronTable1, IronTable2, IronTable3, IronTable4, IronTable5, IronTable6, IronTable7],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: " Our wall-mountable foldable ironing table is perfect for both homes and beauty parlors Table Size: 1220mm × 420mm Materials Used: 16mm high-quality plywood Ebco 300mm anti-corrosion table bracket Key Features: Foldable space-saving design / Can be folded away to save space Strong and stable triangle bracket (Ebco) Easy to install without any professional help Available in 3 beautiful colors Can be customized as a study table, kitchen table, or laptop desk based on customer preference Free delivery + fitting up to 20 km!"
    },
    {
        id: "48",
        title: 'Naco ABC Malt Powder',
        category: 'Health & Wellness',
        content: 'Energy and health in one glass',
        oldPrice: '650',
        offer: "8%",
        offerPrice: "595",
        count: 100,
        gallery: [medicine1, medicine2],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Do you feel tired every day? Are your children getting complete nutrition? Energy and health in one glass Naco ABC Malt Powder Suitable for both children and adults Taste and nutrition together Provides daily essential nutrition Easy to prepare Delicious and healthy choice"
    },
    {
        id: "49",
        title: 'Changalam Paranda Thailam (Herbal Pain Relief Oil)',
        category: 'Health & Wellness',
        content: 'Traditional Ayurvedic herbal oil for pain relief',
        oldPrice: '220',
        offer: "9%",
        offerPrice: "200",
        count: 100,
        gallery: [Thailam1, Thailam2],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Changalam Paranda Thailam is a traditional Ayurvedic herbal oil made from natural medicinal plants, especially Changalam Paranda (Cissus quadrangularis). It is known for its powerful pain-relieving and healing properties. This oil helps reduce joint pain, muscle pain, and bone-related discomfort. Regular use supports faster recovery from injuries and improves mobility. | 100ml"
    },
    {
        id: "50",
        title: 'Ojeenam Foods Sweet Potato Powder',
        category: 'Health & Wellness',
        content: 'Ojeenam Foods Sweet Potato Powder',
        oldPrice: '120',
        offer: "25%",
        offerPrice: "90",
        count: 100,
        gallery: [SweetPotato1, SweetPotato2],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Ojeenam Foods Sweet Potato Powder is a natural and nutritious food supplement specially prepared for babies and toddlers. Made from carefully selected sweet potatoes, this powder is rich in fiber, vitamins, and essential nutrients that support healthy growth and development.It is easy to digest and can be prepared quickly as a smooth porridge. Ideal for introducing solid foods to your little one, it helps provide natural energy and supports overall immunity."
    },
    {
        id: "51",
        title: 'Ojeenam Foods Hungry Baby Kunnankaya Powder',
        category: 'Health & Wellness',
        content: 'Ojeenam Foods Hungry Baby Kunnankaya Powder',
        oldPrice: '220',
        offer: "18%",
        offerPrice: "180",
        count: 100,
        gallery: [Kunnankaya1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Ojeenam Foods Hungry Baby Kunnankaya Powder is a wholesome and nutritious baby food made from premium quality raw banana (Kunnankaya). It helps improve digestion, boost immunity, and nourish growing babies naturally.This powder is rich in natural carbohydrates, fiber, and essential nutrients that support healthy weight gain and energy levels. Easy to prepare and gentle on tiny tummies."
    },
    {
        id: "52",
        title: 'Ojeenam Foods Hungry Baby Healthmix Powder (250g)',
        category: 'Health & Wellness',
        content: 'Ojeenam Foods Hungry Baby Healthmix Powder (250g)',
        oldPrice: '180',
        offer: "17%",
        offerPrice: "150",
        count: 100,
        gallery: [SweetPotato2, Healthmix1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Ojeenam Foods Hungry Baby Healthmix Powder is a nutrient-rich blend specially designed to provide complete nourishment for babies and toddlers. Packed with natural ingredients, it offers high protein content and essential nutrients needed for healthy development.This health mix supports digestion, boosts natural energy, and helps maintain overall wellness. A perfect daily nutrition choice for growing babies."
    },
    {
        id: "53",
        title: 'Ojeenam Foods Hungry Baby Sprouted Ragi Powder',
        category: 'Health & Wellness',
        content: 'Ojeenam Foods Hungry Baby Sprouted Ragi Powder',
        oldPrice: '120',
        offer: "25%",
        offerPrice: "90",
        count: 100,
        gallery: [NavaraRagiPowder],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Ojeenam Foods Hungry Baby Sprouted Ragi Powder is a wholesome and nutritious baby food made from carefully selected sprouted ragi. Rich in iron and essential nutrients, it supports healthy growth and improves digestion in babies. The sprouting process enhances nutrient absorption, making it an ideal choice for your little one’s healthy start. Perfect for preparing smooth, tasty porridge for babies."
    },
    {
        id: "54",
        title: 'Ojeenam Foods Hungry Baby Navara Banana Mix',
        category: 'Health & Wellness',
        content: 'Ojeenam Foods Hungry Baby Navara Banana Mix',
        oldPrice: '180',
        offer: "22%",
        offerPrice: "140",
        count: 100,
        gallery: [NavaraBananaMix],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Ojeenam Foods Hungry Baby Navara Banana Mix is a nutritious blend specially crafted for babies. Made with Navara rice and natural banana, this mix supports digestive health and helps boost the immune system. It is protein-rich and provides essential nutrients required for healthy development. A tasty and nourishing meal option for growing babies."
    },
    {
        id: "55",
        title: 'Ojeenam Foods Hungry Baby Navara Rice Powder',
        category: 'Health & Wellness',
        content: 'Ojeenam Foods Hungry Baby Navara Rice Powder',
        oldPrice: '80',
        offer: "25%",
        offerPrice: "60",
        count: 100,
        gallery: [NavaraRicePowder],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Ojeenam Foods Hungry Baby Navara Rice Powder is made from premium quality Navara rice, known for its high nutritional value. It is rich in fiber and iron, helping support weight gain and overall growth in babies. This easily digestible rice powder ensures healthy nutrition in every scoop and makes a perfect first food for infants."
    },
    {
        id: "56",
        title: 'Pancha Loha polished chains (24 inch)',
        category: 'Traditional Jewellery',
        content: 'Pancha Loha polished chains (24 inch)',
        oldPrice: '2400',
        offer: "12%",
        offerPrice: "2100",
        count: 100,
        gallery: [Panchaloha1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Pancha Loha is a traditional alloy made from five metals and is widely used in spiritual jewellery and temple ornaments. This chain is ideal for wearing with pendants, especially religious or astrological pendants, making it perfect for daily wear as well as special occasions."
    },
    {
        id: "57",
        title: 'Pancha Loha Polished Designer Chain – 30 Inch',
        category: 'Traditional Jewellery',
        content: 'Pancha Loha Polished Designer Chain – 30 Inch',
        oldPrice: '3000',
        offer: "16%",
        offerPrice: "2500",
        count: 100,
        gallery: [Panchaloha2, Panchaloha3, Panchaloha4, Panchaloha5],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Add a touch of traditional elegance with this beautifully crafted Pancha Loha polished designer chain. Made from the sacred five-metal alloy known as Pancha Loha, this chain carries both cultural significance and stylish appeal. The chain features a detailed link pattern with a rich gold-polished finish that gives it a premium look. Its 24-inch length makes it perfect for wearing alone or pairing with pendants, especially spiritual or traditional pendants."
    },
    {
        id: "58",
        title: 'Pancha Loha Polished Ring – Traditional Sacred Ring  size 2.2',
        category: 'Traditional Jewellery',
        content: 'Pancha Loha Polished Ring – Traditional Sacred Ring  size 2.2',
        oldPrice: '700',
        offer: "21%",
        offerPrice: "550",
        count: 100,
        gallery: [PanchalohaRing1, PanchalohaRing2, PanchalohaRing3, PanchalohaRing4, PanchalohaRing5, PanchalohaRing6, PanchalohaRing7],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Experience the spiritual and traditional essence of Indian craftsmanship with this Pancha Loha Polished Ring Set. Crafted from the sacred alloy known as Pancha Loha (five-metal blend), these rings symbolize balance, positivity, and spiritual harmony."
    },
    {
        id: "59",
        title: 'Pancha Loha Polished Ring – Traditional Sacred Ring  size 2.2',
        category: 'Traditional Jewellery',
        content: 'Pancha Loha Polished Ring – Traditional Sacred Ring  size 2.2',
        oldPrice: '1100',
        offer: "18%",
        offerPrice: "900",
        count: 100,
        gallery: [PanchalohaRing8, PanchalohaRing9, PanchalohaRing10, PanchalohaRing11, PanchalohaRing12, PanchalohaRing13, PanchalohaRing14, PanchalohaRing15, PanchalohaRing16, PanchalohaRing17, PanchalohaRing18, PanchalohaRing19, PanchalohaRing20, PanchalohaRing21, PanchalohaRing22, PanchalohaRing23, PanchalohaRing24, PanchalohaRing25, PanchalohaRing26, PanchalohaRing27],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Experience the spiritual and traditional essence of Indian craftsmanship with this Pancha Loha Polished Ring Set. Crafted from the sacred alloy known as Pancha Loha (five-metal blend), these rings symbolize balance, positivity, and spiritual harmony."
    },
    {
        id: "60",
        title: 'Pancha Loha Polished Designer Bangle – Traditional Center Bead Design (Pair)',
        category: 'Traditional Jewellery',
        content: 'Pancha Loha Polished Designer Bangle – Traditional Center Bead Design (Pair)',
        oldPrice: '1100',
        offer: "18%",
        offerPrice: "900",
        count: 100,
        gallery: [PanchalohaRing28],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Enhance your traditional look with this Pancha Loha Polished Designer Bangle Pair, crafted with a beautiful center bead motif and classic textured pattern. Made from the sacred Pancha Loha (five-metal alloy), this bangle combines traditional craftsmanship with a rich golden polished finish."
    },
    {
        id: "61",
        title: "Pancha Loha Polished Heart & Ring Pattern Chain – Elegant Long Design",
        category: "Traditional Jewellery",
        content: "Pancha Loha Polished Heart & Ring Pattern Chain – Elegant Long Design",
        oldPrice: "1800",
        offer: "41%",
        offerPrice: "1050",
        count: 100,
        gallery: [Panchaloha6, Panchaloha7, Panchaloha8],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Stylish Heart & Ring Motif",
            "Lightweight & Comfortable",
            "100% Quality Assurance"
        ],
        description: "This Pancha Loha Polished Chain features a unique combination of heart and circular motifs, giving it a stylish and elegant appeal. Made from the traditional five-metal alloy, it offers both cultural value and modern charm. Perfect for pairing with ethnic and casual outfits."
    },
    {
        id: "62",
        title: 'Neem Soap',
        category: 'Soap',
        content: 'Its antibacterial and antimicrobial properties would help purify the skin.',
        oldPrice: '200',
        offer: "40%",
        offerPrice: "120",
        count: 100,
        gallery: [NeemSoap],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "Neem soap offers numerous benefits for skincare, including its antimicrobial, anti-inflammatory, and antioxidant properties. It can be used to cleanse, soothe, and moisturize the skin, making it a valuable addition to any skincare routine."
    },
    {
        id: "63",
        title: 'Muradh Long Lasting Perfume 10 ml',
        category: 'Perfumes',
        content: 'Korean Sweet Touch',
        oldPrice: '325',
        offer: "23%",
        offerPrice: "249",
        count: 100,
        gallery: [SulthanPerfume1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "A smooth fragrance with a subtle Korean-inspired touch."
    },
    {
        id: "64",
        title: 'Shadow Long Lasting Perfume 35 ml',
        category: 'Perfumes',
        content: 'Light fruit touch',
        oldPrice: '859',
        offer: "30%",
        offerPrice: "599",
        count: 100,
        gallery: [SulthanPerfume2],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "A rich floral fragrance with an executive and premium character."
    },
    {
        id: "65",
        title: 'Refresh Sample Perfume 35 ml',
        category: 'Perfumes',
        content: 'Light Fruity touch',
        oldPrice: '859',
        offer: "30%",
        offerPrice: "599",
        count: 100,
        gallery: [SulthanPerfume3],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "A fresh fruity fragrance with a vibrant and uplifting feel."
    },
    {
        id: "66",
        title: 'Emarati - Bold Oriental Perfume 10 ml',
        category: 'Perfumes',
        content: 'Oudh Touch',
        oldPrice: '325',
        offer: "23%",
        offerPrice: "249",
        count: 100,
        gallery: [SulthanPerfume6],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "A bold oriental fragrance with a classic oudh touch."
    },
    {
        id: "67",
        title: 'Identity - light and pleasant Perfume 10 ml',
        category: 'Perfumes',
        content: 'Light and pleasant Perfume',
        oldPrice: '325',
        offer: "23%",
        offerPrice: "249",
        count: 100,
        gallery: [SulthanPerfume7],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "A light and pleasant fragrance inspired by Marj."
    },
    {
        id: "68",
        title: 'Refresh - fresh fruity Perfume 10 ml',
        category: 'Perfumes',
        content: 'Fresh fruity Perfume',
        oldPrice: '325',
        offer: "23%",
        offerPrice: "249",
        count: 100,
        gallery: [SulthanPerfume8],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "A fresh fruity fragrance with a vibrant and uplifting feel."
    },
    {
        id: "69",
        title: 'Refresh - fresh fruity Perfume 100 ml',
        category: 'Perfumes',
        content: 'Light Fruity touch',
        oldPrice: '2000',
        offer: "25%",
        offerPrice: "1499",
        count: 100,
        gallery: [SulthanPerfume5],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Easy Returns",
            "Easy to Order",
            "100% Quality Assurance"
        ],
        description: "A fresh fruity fragrance with a vibrant and uplifting feel."
    },
    {
        id: "70",
        title: "Pawpetals Wall Hanging Planter with Artificial Plant – Modern Decorative Design",
        category: "Home Decor",
        content: "Stylish Wall Hanging Planter",
        oldPrice: "620",
        offer: "20%",
        offerPrice: "499",
        count: 100,
        gallery: [PawpetalsPlanter1, PawpetalsPlanter2, PawpetalsPlanter3],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Modern Wall Decor",
            "Low Maintenance Artificial Plant",
            "100% Quality Assurance"
        ],
        description: "Enhance your living space with this Pawpetals Wall Hanging Planter featuring a beautifully designed metal frame and a lush artificial plant. Perfect for adding a touch of greenery without maintenance, this stylish decor piece blends seamlessly with modern interiors, making it ideal for living rooms, bedrooms, or office spaces."
    },
    {
        id: "71",
        title: "Pawpetals 3ft Artificial Alocasia Plant – 18 Leaves Premium Design",
        category: "Home Decor",
        content: "Artificial Alocasia Plant",
        oldPrice: "399",
        offer: "20%",
        offerPrice: "319",
        count: 100,
        gallery: [PawpetalsPlant1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "3ft Tall Decorative Plant",
            "18 Realistic Leaves Design",
            "Premium Quality PP Material",
            "Low Maintenance & Durable"
        ],
        description: "Bring a refreshing natural touch to your home with this Pawpetals 3ft Artificial Alocasia Plant featuring 18 beautifully crafted leaves with fine detailing. Made from premium quality PP material, this plant offers a realistic look without any maintenance. Perfect for living rooms, offices, or indoor decor setups."
    },
    {
        id: "72",
        title: "Pawpetals 6ft Big Artificial Bird of Paradise Plant – Premium Realistic Tree",
        category: "Home Decor",
        content: "Large Artificial Bird of Paradise Plant",
        oldPrice: "2100",
        offer: "19%",
        offerPrice: "1699",
        count: 100,
        gallery: [PawpetalsPlant2, PawpetalsPlant3, PawpetalsPlant4],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "6ft Tall Statement Plant",
            "Realistic Tropical Design",
            "Premium Quality Material",
            "Perfect for Home & Office Decor"
        ],
        description: "Transform your space with this Pawpetals 6ft Big Artificial Bird of Paradise Plant, designed to bring a bold tropical vibe to any interior. Crafted with premium quality materials, this realistic tree plant features large, lifelike leaves that add elegance and freshness without any maintenance. Ideal for living rooms, offices, and modern decor setups."
    },
    {
        id: "73",
        title: "Pawpetals Artificial Tabletop Plants with Pot – Compact Desk & Shelf Decor",
        category: "Home Decor",
        content: "Mini Tabletop Artificial Plant",
        oldPrice: "350",
        offer: "20%",
        offerPrice: "279",
        count: 100,
        gallery: [PawpetalsPlant5],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Compact Size – Below 1 ft",
            "Perfect for Desk & Shelf Decor",
            "Comes with Stylish Pot",
            "Low Maintenance & Durable"
        ],
        description: "Add a touch of greenery to your workspace or home with this Pawpetals Artificial Tabletop Plant. Designed for desks, shelves, and small spaces, this compact plant comes with a stylish pot and realistic detailing. Made from quality materials, it offers a fresh and elegant look without any maintenance."
    },
    {
        id: "74",
        title: "Pawpetals Artificial Begonia Plant with Pot – Shelf & Workspace Decor",
        category: "Home Decor",
        content: "Artificial Begonia Plant",
        oldPrice: "590",
        offer: "19%",
        offerPrice: "475",
        count: 100,
        gallery: [PawpetalsPlant6],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Free Shipping",
            "Realistic Begonia Leaf Design",
            "Perfect for Shelf & Workspace",
            "Comes with Stylish Pot",
            "Low Maintenance & Durable"
        ],
        description: "Upgrade your interior decor with this Pawpetals Artificial Begonia Plant, designed with vibrant and realistic leaves just like the picture. Ideal for shelves, desks, and workspace settings, it comes with a stylish pot and requires no maintenance, making it a perfect hassle-free decor choice."
    },
    {
        id: "75",
        title: "9 In 1 Electric Spin Scrubber /Electric Spin Cleaning Brush",
        category: "Home Appliances",
        content: "9-in-1 Multi-Functional Electric Spin Scrubber",
        oldPrice: "850",
        offer: "14%",
        offerPrice: "731",
        count: 100,
        gallery: [hardware, hardwareLogo],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "9-in-1 Versatile Cleaning Heads",
            "Dual Speed Settings for Deep Cleaning",
            "Rechargeable & Cordless Operation",
            "Extendable Handle for Easy Reach",
            "Heavy Duty & Durable Design"
        ],
        description: "The 9-in-1 Electric Spin Scrubber is the ultimate cleaning tool for your home. Featuring dual speed settings and nine replaceable heads, it effortlessly tackles dirt and grime on floors, tiles, bathrooms, and more. The cordless, rechargeable design with an extendable handle ensures you can reach every corner without strain. Experience a deeper clean with less effort."
    },
    {
        id: "76",
        title: "Zeyra Enterprises 10-Pack Heavy Duty Adhesive Wall Hooks",
        category: "Home Utilities",
        content: "10-Pack Heavy Duty Adhesive Wall Hooks",
        oldPrice: "199",
        offer: "10%",
        offerPrice: "179",
        count: 100,
        gallery: [Hook1, Hook2, Hook3, Hook4, Hook5, Hook6],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "10-Pack Heavy Duty Adhesive Hooks",
            "Stainless Steel & PVC Construction",
            "Transparent & Waterproof Design",
            "Oilproof & Durable for Outdoor Use",
            "Perfect for Bathroom, Kitchen & Shower"
        ],
        description: "Zeyra Enterprises 10-Pack Heavy Duty Adhesive Wall Hooks are designed for maximum strength and versatility. Made from high-quality stainless steel and PVC, these transparent hooks are waterproof and oilproof, making them ideal for bathrooms, kitchens, shower doors, and outdoor use. Easy to install without drilling, they provide a reliable solution for organizing your home utility items."
    },
    {
        id: "77",
        title: "Loundry Pods / Cloth Stain Removing Pods",
        category: "Home Utilities",
        content: "Loundry Pods / Cloth Stain Removing Pods",
        oldPrice: "199",
        offer: "10%",
        offerPrice: "179",
        count: 100,
        gallery: [loundryPods1],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "Loundry Pods / Cloth Stain Removing Pods / Fabric Softener Capsule / Fragrance Detergent Pods For Washing Machine/ 5 in 1 Loundry Pods"
        ],
        description: "Loundry Pods / Cloth Stain Removing Pods / Fabric Softener Capsule / Fragrance Detergent Pods For Washing Machine/ 5 in 1 Loundry Pods"
    },
    {
        id: "78",
        title: "Laundry Pods / Cloth Stain Removing Pods",
        category: "Home Utilities",
        content: "5 in 1 Laundry Pods for effective stain removal and fresh fragrance",
        oldPrice: "120",
        offer: "30%",
        offerPrice: "84",
        count: 100,
        gallery: [loundryPods2],
        freeShipping: true,
        isReturnable: true,
        deliveryPolicy: "Free Delivery in Kerala",
        highlights: [
            "5 in 1 Laundry Pods",
            "Powerful stain removal",
            "Built-in fabric softener",
            "Long-lasting fragrance",
            "Suitable for washing machines"
        ],
        description: "High-quality 5 in 1 laundry pods designed for powerful stain removal, fabric care, and long-lasting freshness. Easy to use and perfect for all types of washing machines."
    },
    {
        id: "79",
        title: "66L Storage Bag Box / Cloth Organizer",
        category: "Home Utilities",
        content: "66 Litre foldable storage box for clothes, blankets, and toys",
        oldPrice: "399",
        offer: "25%",
        offerPrice: "299",
        count: 100,
        gallery: [storageBagImage],
        freeShipping: false,
        isReturnable: false,
        deliveryPolicy: "No Free Delivery",
        highlights: [
            "66 Litre large storage capacity",
            "Durable Oxford fabric material",
            "Strong steel frame support",
            "Foldable and space-saving design",
            "Ideal for clothes, blankets, toys, and bedsheets"
        ],
        description: "Spacious 66L storage organizer made with durable Oxford fabric and a strong steel frame. Perfect for storing clothes, blankets, toys, and more. Foldable design makes it easy to store when not in use."
    },
    {
        id: "80",
        title: "Fabric Storage Basket / Oxford Cloth Storage Box",
        category: "Home Utilities",
        content: "26 Litre foldable fabric storage box for clothes, jeans, and wardrobe organization",
        oldPrice: "250",
        offer: "28%",
        offerPrice: "181",
        count: 100,
        gallery: [storageBagImage1],
        freeShipping: false,
        isReturnable: false,
        deliveryPolicy: "No Free Delivery",
        highlights: [
            "26 Litre storage capacity",
            "Durable Oxford cloth material",
            "Strong steel frame support",
            "Foldable and space-saving design",
            "Ideal for clothes, jeans, wardrobe organization"
        ],
        description: "Foldable fabric storage basket made with durable Oxford cloth and a strong steel frame. Perfect for organizing clothes, jeans, and wardrobe essentials. Compact 26L design with a stylish printed finish, easy to store when not in use."
    },
    {
        id: "81",
        title: "48 Pcs Double Side Marker Pen Set / Art Markers",
        category: "Stationery & Art Supplies",
        content: "48 pcs dual tip alcohol marker pens for sketching, drawing, and calligraphy",
        oldPrice: "370",
        offer: "16%",
        offerPrice: "311",
        count: 100,
        gallery: [markerPenImage],
        freeShipping: false,
        isReturnable: false,
        deliveryPolicy: "No Free Delivery",
        highlights: [
            "48 vibrant color marker pens",
            "Dual tip design – broad & fine tips",
            "Smooth alcohol-based ink",
            "Perfect for sketching, painting, and calligraphy",
            "Quick-drying and long-lasting colors"
        ],
        description: "Professional 48 pcs dual-tip marker pen set designed for artists, students, and hobbyists. Features high-quality alcohol-based ink for smooth application, vibrant colors, and quick drying. Ideal for sketching, coloring, calligraphy, and creative artwork."
    },
    {
        id: "82",
        title: "6 Slot Cereal Dispenser / Wall Mount Storage Container",
        category: "Home Utilities",
        content: "6-grid wall-mounted dry food dispenser for cereals, rice, pulses, and grains",
        oldPrice: "999",
        offer: "6%",
        offerPrice: "941",
        count: 100,
        gallery: [cerealDispenserImage],
        freeShipping: false,
        isReturnable: false,
        deliveryPolicy: "No Free Delivery",
        highlights: [
            "6 separate storage compartments",
            "Wall-mounted space-saving design",
            "Food-grade durable plastic material",
            "Easy dispensing with button control",
            "Ideal for cereals, rice, pulses, and dry foods"
        ],
        description: "Multifunctional 6-slot cereal and grain dispenser designed for convenient kitchen storage. Features a wall-mounted, space-saving design with easy dispensing buttons for each compartment. Keeps dry food items fresh, organized, and easily accessible."
    },
    {
        id: "83",
        title: "6 Cell Drawer Organiser / Wall Mount Socks Organizer for Wardrobe, Underwear, Ties, Socks, Data Cable, Spices .",
        category: "Home Utilities",
        content: "Multifunctional 6-grid punch-free wall mount organizer for undergarments, socks, and small items",
        oldPrice: "288",
        offer: "16%",
        offerPrice: "241",
        count: 100,
        gallery: [drawerOrganizerImage],
        freeShipping: false,
        isReturnable: false,
        deliveryPolicy: "No Free Delivery",
        highlights: [
            "6 separate storage compartments",
            "Punch-free wall mount design",
            "Ideal for socks, underwear, ties, and more",
            "Multipurpose storage solution",
            "Space-saving and easily accessible"
        ],
        description: "Versatile 6-cell drawer and wall-mount organizer designed to keep your wardrobe and space tidy. Features a punch-free installation and 6 grids perfect for storing undergarments, lingerie, socks, ties, data cables, or even spices. A space-saving and multifunctional storage holder."
    },
    {
        id: "84",
        title: "2-in-1 Kids Projector Flashlight Toy with Image Slides",
        category: "Kids & Toys",
        content: "Fun 2-in-1 projector flashlight toy for kids with multiple image slides and soft light",
        oldPrice: "144",
        offer: "15%",
        offerPrice: "122",
        count: 100,
        gallery: [ledFlashlightImage],
        freeShipping: false,
        isReturnable: false,
        deliveryPolicy: "No Free Delivery",
        highlights: [
            "2-in-1 projector and flashlight function",
            "Includes multiple themed image slides",
            "Lightweight and kid-friendly design",
            "Easy rotating slide mechanism",
            "Soft and safe light for children's eyes",
            "Colorful and attractive design"
        ],
        description: "A fun and educational 2-in-1 kids projector flashlight toy that works as both a flashlight and mini projector. Comes with multiple image slide discs featuring fun themes like animals and space. Designed to be lightweight, safe, and easy for kids to use. Perfect for storytelling, bedtime fun, and gifting."
    },
    {
        id: "85",
        title: "Super Bright Rechargeable LED Flashlight with Digital Display Light",
        category: "Home Utilities",
        content: "High-intensity rechargeable LED flashlight with 4 modes, COB side light, and battery display",
        oldPrice: "251",
        offer: "16%",
        offerPrice: "211",
        count: 100,
        gallery: [kidsProjectorImage],
        freeShipping: false,
        isReturnable: false,
        deliveryPolicy: "No Free Delivery",
        highlights: [
            "Super bright high-intensity beam",
            "4 LED lights for powerful illumination",
            "USB rechargeable (no batteries needed)",
            "4 lighting modes: High, Medium, Low, Flash",
            "COB side light for wide-area lighting",
            "Digital battery level display",
            "Durable and heat-resistant body",
            "Portable and easy to carry"
        ],
        description: "Super bright rechargeable LED flashlight designed for powerful illumination and long-distance visibility. Features 4 LED lights, multiple lighting modes, and a COB side light for wider coverage. Comes with a digital display to monitor battery level and supports convenient USB charging. Ideal for camping, emergencies, night walking, outdoor work, and security use."
    }
];
